import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-dot-menu",
  "use": "ico-dot-menu-usage",
  "viewBox": "0 0 384 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\" id=\"ico-dot-menu\">\n    <title>More</title>\n    <g>\n        <path d=\"M50 304c-28 0-50-21-50-48 0-26 22-48 50-48s50 22 50 48c0 27-22 48-50 48zm142 0c-28 0-50-21-50-48 0-26 22-48 50-48s50 22 50 48c0 27-22 48-50 48zm142 0c-28 0-50-21-50-48 0-26 22-48 50-48s50 22 50 48c0 27-22 48-50 48z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol